module.exports = __webpack_public_path__ + "static/img/1.f134b63.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/eng/1.png
// module id = /vl2
// module chunks = 0